import React, { useEffect } from 'react';
import './index.css';

// Componentes de layout
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Componentes de secciones
import Hero from './components/sections/Hero';
import Properties from './components/sections/Properties';
import Benefits from './components/sections/Benefits';
import Testimonials from './components/sections/Testimonials';
import About from './components/sections/About';
import Contact from './components/sections/Contact';

function App() {
  // Verificar si hay preferencia de tema oscuro
  useEffect(() => {
    if (localStorage.theme === 'dark' || 
        (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  return (
    <div className="App min-h-screen bg-light dark:bg-dark">
      <Header />
      <main>
        <Hero />
        <Properties />
        <Benefits />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
